const tokenKey = process.env.REACT_APP_AUTH_TOKEN_KEY || 'loginDetails';

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem(tokenKey);
};

export const setToken = (token: string) => {
  localStorage.setItem(tokenKey, token);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};

export const getToken = (): string | null => {
  return localStorage.getItem(tokenKey);
};
